import { z } from 'zod';
import { FlowGroupNodeSchema } from './groupNode.js';
import { FlowStickyNoteNodeSchema } from './stickyNotes.js';
export const FlowDecorationNodeSchema = z.discriminatedUnion('decorationType', [
    FlowStickyNoteNodeSchema,
    FlowGroupNodeSchema,
]);
export const FlowDecorationDataSchema = z.object({
    nodes: FlowDecorationNodeSchema.array(),
});
//# sourceMappingURL=nodes.js.map